import { createSelector } from '@reduxjs/toolkit'
import { CommentingSliceState } from 'sierra-client/state/commenting/types'
import { RootState } from 'sierra-client/state/types'

const selectSlice = (rootState: RootState): CommentingSliceState => rootState.commenting

export const selectCurrentBrowsing = createSelector([selectSlice], slice => slice.browsing)
